import React, { useState,useEffect, useContext } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {SelectDataListSearch} from '@gull'
import swal from "sweetalert2";
import axios from 'axios'
import { IsAuthContext } from 'app/App';

const useLoad = () => {
    const t = useTranslate();

    const [formateHardData,setFormateHardData]=useState([]) 
    const [articleFields_id,setArticleFields_id] = useState([])
    const [articleFields,setArticleFields] = useState([])
    const [customfields,setCustomFields]=useState([])
    const [loading,setLoading] = useState({
        custom_fields:true,
        article_fields:true
    })

    let infoException=[
        'id',
        'created_at',
        'updated_at',
        'custom_fields',
        'company_id',
        'kill_promo',
        'archive',
        'provisoire',
        'create_from',
        'last_date_buy'
    ]

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/section_ecom_conf/get_article_fields"
            ).then((response) => {
                let arr = []
                let arr_id = []
                response.data.datas.map(value=>{
                    if(!infoException.includes(value)){
                        if(value.includes('_id')){
                            arr.push(value.replace('_id',''))
                            arr_id.push(value.replace('_id',''))//On met tous les champs qui ont _id à la fin car pour shopnc ces champs là doivent etre envoyé au back avec la terminaison .name
                        }else{
                            arr.push(value)
                        }
                    }
                })
                setArticleFields(arr)
                setArticleFields_id(arr_id)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }else {
                    messageError='unknowError'
                }
                swal.fire(t(messageError), "", "error");
            })
            setLoading(prev => ({...prev,article_fields:false}))
        })()
    }, [])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
            ).then((response) => {
                setCustomFields(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }else {
                    messageError='unknowError'
                }
                swal.fire(t(messageError), "", "error");
            })
            setLoading(prev => ({...prev,custom_fields:false}))
        })()
    }, [])

    useEffect(function () {
            let arr = []
            articleFields.map(value=>{
                if(value=='name'){
                    arr.push({id:'name', name:t('itemName')})
                }else if(value=='indice'){
                    arr.push({id:'indice', name:t('prmpIndice')})
                }else if(value=='price'){
                    arr.push({id:'price', name:t('priceTtcB2c')})
                }else if(value=='price_b2b'){
                    arr.push({id:'price_b2b', name:t('priceTtcB2b')})
                }else if(value=='provisoire'){
                    arr.push({id:'provisoire', name:t('temporaryItem')})
                }else if(value=='internalid'){
                    arr.push({id:'internalid', name:t('internalId')})
                }else if(value=='havestock'){
                    arr.push({id:'havestock', name:t('itemHaveStock')})
                }else if(value=='last_pr_devise'){
                    arr.push({id:'last_pr_devise', name:t('last_pr')})
                }else if(value=='last_buy_price'){
                    arr.push({id:'last_buy_price', name:t('last_purchase_price')})
                }else if(value=='last_buy_price_devise'){
                    arr.push({id:'last_buy_price_devise', name:t('last_purchase_price_devise')})
                }else if(value=='last_devise'){
                    arr.push({id:'last_devise', name:t('last_devise_achat')})
                }else if(value=='transform'){
                    arr.push({id:'transform', name:t('itemsTransform')})
                }else if(value=='to_prepare'){
                    arr.push({id:'to_prepare', name:t('itemToPrepare')})
                }else if(value=='on_demand'){
                    //on ne fait rien
                }else{
                    arr.push({id:value, name:t(value)})
                }
            })
    
            setFormateHardData(arr)
    }, [articleFields])

    return [formateHardData,customfields,articleFields,articleFields_id,loading]
}

const AbonnementNameField = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext); //AuthParams

    const [infos,setInfos]=useState({})
    
    const [formateHardData,customfields,articleFields,articleFields_id,loading] = useLoad();

    const [valueInput,setValueInput]=useState('') 
    const [disabledValidSearch,setDisabledValidSearch]=useState(false) 
    const [validButton,setValidButton]=useState(false) 
    const [success,setSuccess]=useState('') 

    const onSubmit = async () =>{
        let field
        if(articleFields.includes(infos.id) || infos.id=='name' || infos.id=='indice' || infos.id===''){
            if(articleFields_id.includes(infos.id)){
                //Si la valeur id fait parti de la liste, il faut ajouter .name en terminaison pour le back
                field = infos.id+'.name'
            }else{
                field = infos.id
            }
        }else{
            //Pour les customfields
            field = infos.name
        }

        setValidButton(true)
        const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/article/abonnement_name_field/"+authParam.company?.id,{
            abonnement_name_field:field
        }
        ).then((response) => {
            if(!response.data.valid){
                swal.fire(t('unknowError'), "", "error");
            }
            else{
                setSuccess(true)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");

        })
        setValidButton(false)
        setTimeout(()=>{
            setSuccess(false)
        },1000)  
    }

    const datas = [{id:'',name:'-- Select --'}].concat(customfields).concat(formateHardData)

    useEffect(function () {
        if (!loading.custom_fields && !loading.article_fields) {
            if (authParam.company?.advanceparams?.abonnement_name_field) {
                let current = datas.find(value => value.id==authParam.company?.advanceparams?.abonnement_name_field) // Pour article field
                if (!current) current = datas.find(value => value.name==authParam.company?.advanceparams?.abonnement_name_field) // Pour custom field
                
                if (current) {
                    setInfos({name:current.name,id:current.id})
                    setValueInput(current.name)
                }
            }
        }
    }, [loading])

    return (
        <div className='row d-flex align-items-center'>
            <div className='col-10 form-group'>
                <label>{t('field')}</label>
                <SelectDataListSearch 
                    datas={datas} 
                    ids={infos}
                    setIds={setInfos}
                    valueInput={valueInput}
                    setValueInput={setValueInput}
                    setDisabledValidSearch={setDisabledValidSearch}
                    from='selectEcomConnect'
                    writeLabel={true}
                    blockSearchValid={true}
                />
            </div>
            <div className='col-2'>
                <button disabled={disabledValidSearch || (valueInput=='' || !valueInput) || validButton} className='btn btn-sm btn-primary' onClick={()=>onSubmit()}>{validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}</button>
            </div>
            {(success) ? <div className="fw-bold text-success mt-1">{t('successOperation')}</div> : false}
        </div>
    )
};

export default AbonnementNameField;